import type { SnackbarVariant } from '../../useSnackbarsStore.types'

/**
 * Generates a consistent hash from snackbar variant and message for deduplication.
 * Uses a simple string hashing algorithm (DJB2) for fast, consistent results.
 *
 * @param variant - The snackbar variant (error, warning, info, alert)
 * @param message - The message content
 * @returns A hash string prefixed with 'snackbar-' for identification
 */
export const hashSnackbarContent = (variant: SnackbarVariant, message: string): string => {
  const str = `${variant}:${message}`
  let hash = 5381

  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i) // hash * 33 + c
  }

  // Convert to unsigned 32-bit integer and then to string
  return `snackbar-${(hash >>> 0).toString(36)}`
}
